import {STORAGE_ALLOWLIST, STORAGE_NAMESPACE_PREFIX_ALLOWLIST} from 'common/gdpr-constants';

export function validateKeyValue(key: string, value: string): void {
  if (typeof key === `undefined` || key === null || key === ``) {
    throw new Error(`@key cannot be null, undefined, or empty`);
  }

  if (typeof value === `undefined` || value === null || value === ``) {
    throw new Error(`@value cannot be null, undefined, or empty`);
  }
}

// set of localStorage keys that are always allowed regardless of GDPR status
const GDPR_KEY_ALLOWLIST = new Set(STORAGE_ALLOWLIST.map((key) => key.toLowerCase()));

// namespace prefixes that are always allowed (for NamespacedLocalStorage keys like "banners:12345:key")
const GDPR_NAMESPACE_PREFIX_ALLOWLIST = STORAGE_NAMESPACE_PREFIX_ALLOWLIST.map((prefix) => prefix.toLowerCase());

export function isAllowedByGdpr(key: unknown) {
  return GDPR_KEY_ALLOWLIST.has(typeof key === `string` ? key.toLowerCase() : ``);
}

export function isAllowedNamespacePrefix(key: string): boolean {
  const lowerKey = key?.toLowerCase();
  if (!lowerKey) {
    return false;
  }
  return GDPR_NAMESPACE_PREFIX_ALLOWLIST.some((prefix) => lowerKey.startsWith(`${prefix}:`));
}
